import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { Box, IconButton, Typography } from '@material-ui/core';
import { ReactComponent as BackArrowIcon } from 'img/arrow-circle-left.svg';

interface IPayrollReportHeader {
  title: string | JSX.Element;
  backRedirectLink?: string;
  isEmployeesReport?: boolean;
}

const PayrollReportHeader: FC<IPayrollReportHeader> = ({
  backRedirectLink,
  title,
  isEmployeesReport = false,
}) => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      width="100%"
      className="payrollReportHeader"
      mb={2}
    >
      <Box display="flex" alignItems="center">
        {backRedirectLink ? (
          <Box mr={1}>
            <Link to={backRedirectLink}>
              <IconButton style={{ padding: 0 }}>
                <BackArrowIcon style={{ width: 17, height: 17 }} />
              </IconButton>
            </Link>
          </Box>
        ) : null}

        {!isEmployeesReport && <Typography variant="h2">{title}</Typography>}
        {isEmployeesReport && <>{title}</>}
      </Box>
    </Box>
  );
};

export default PayrollReportHeader;
